"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var Closure_1 = require("./Closure");
var astUtils_1 = require("./astUtils");
var nextId = function () {
    var num = 0;
    return function () {
        num++;
        return num;
    };
}();
exports.create = function () {
    return {
        id: nextId(),
        _suppress: true,
        _calls: immutable_1.Stack()
    };
};
exports.next = function (visualizer, interpreter) {
    var _calls = visualizer._calls,
        root = visualizer.root,
        _suppress = visualizer._suppress;

    if (!interpreter.node) {
        return visualizer;
    }
    if (interpreter._done) {
        switch (interpreter.node.type) {
            case 'VariableDeclaration':
            case 'FunctionDeclaration':
            case 'IfStatement':
            case 'ExpressionStatement':
            case 'ReturnStatement':
                return visualizer;
            case 'CallExpression':
                if (!_suppress && root) {
                    return Object.assign({}, visualizer, { _suppress: false, _calls: visualizer._calls.pop() });
                } else {
                    return visualizer;
                }
            case 'UnaryExpression':
            case 'BinaryExpression':
            case 'LogicalExpression':
            case 'ConditionalExpression':
            case 'Identifier':
                if (interpreter.node.type === 'Identifier' && interpreter.value instanceof Closure_1.default) {
                    return visualizer;
                }
                if (!_suppress && root) {
                    var callId = visualizer._calls.peek() ? visualizer._calls.peek().__call : undefined;
                    var toReplace = Object.assign({}, interpreter.node, { __call: callId });
                    var replaceWith = Object.assign({}, astUtils_1.createNode(interpreter.value), { __call: callId });
                    return Object.assign({}, visualizer, { id: nextId(), root: astUtils_1.replace(root, toReplace, replaceWith) });
                } else {
                    return visualizer;
                }
            case 'Literal':
            case 'FunctionExpression':
            default:
                return visualizer;
        }
    } else {
        switch (interpreter.node.type) {
            case 'BlockStatement':
                return Object.assign({}, visualizer, { _suppress: true });
            case 'ExpressionStatement':
                var node = interpreter.node;
                if (_calls.isEmpty()) {
                    return Object.assign({}, visualizer, { id: nextId(), root: node.expression, _suppress: false });
                } else {
                    return visualizer;
                }
            case 'VariableDeclaration':
                var decl = interpreter.node;
                if (_calls.isEmpty()) {
                    return Object.assign({}, visualizer, { id: nextId(), root: decl.declarations[0].init });
                } else {
                    return visualizer;
                }
            case 'ReturnStatement':
                var _callId = visualizer._calls.peek().__call;
                var argNode = Object.assign({}, interpreter.node.argument, { __call: _callId });
                if (root) {
                    return Object.assign({}, visualizer, { id: nextId(), root: astUtils_1.replace(root, visualizer._calls.peek(), argNode), _suppress: false });
                } else {
                    return visualizer;
                }
            case 'CallExpression':
                var callNode = Object.assign({}, interpreter.node, { __call: nextId() });
                return Object.assign({}, visualizer, { _calls: visualizer._calls.push(callNode) });
            case 'FunctionDeclaration':
            case 'IfStatement':
            case 'UnaryExpression':
            case 'BinaryExpression':
            case 'LogicalExpression':
            case 'ConditionalExpression':
            case 'Identifier':
            case 'FunctionExpression':
            default:
                return visualizer;
        }
    }
};
//# sourceMappingURL=visualizer.js.map


//////////////////
// WEBPACK FOOTER
// ../source-toolchain/es5/visualizer.js
// module id = 183
// module chunks = 3